// extracted by mini-css-extract-plugin
module.exports = {"buscar":"SearchBar_buscar__3bMHb","btn":"SearchBar_btn__q6G3X"};